import React from "react";
import Navbar from "../Navbar/Navbar";
import classes from "./About.module.css";
import about from "../../assest/energy-grid-hero.jpg";
const About = () => {
  return (
    <div className="container">
      <div>
        <Navbar />
        <div className={`${classes.MainContainer} row`}>
          <div className="col-md-6">
            <div className={classes.AboutBtn}>
              <h3>About Us</h3>
            </div>
            <div style={{ marginTop: "20vh", marginLeft: "1vw" }}>
              <h3 style={{ color: "white", marginBottom: "5vh" }}>The Team</h3>
              <label style={{ color: "white" }}>
                The team at VoltHertz Technologies Pvt Ltd works <br />
                across energy supply, <br />
                energy trading, grid balancing, and ancillary services. <br />
                We understand the practical demands of flexible power, <br />
                reserve capacity, EV charging flexibility, and critical
                equipment delivery.{" "}
                <br /> Our team brings hands-on experience with load banks,{" "}
                <br />
                batteries, generators, CPO platforms, VPP systems, <br />
                Industrial IoT telemetry, and field service to deliver{" "}
                <br />
                tailored solutions that support your energy and grid <br />
                balancing requirements.
              </label>
            </div>
          </div>
          <div
            className="col-md-6"
            style={{
              position: "relative",
              backgroundImage: `url(${about})`,
              height: "83vh",
              borderRadius: "34px",
            }}
          >
            <div className={classes.ContentHeading}>
              <h3>Why Choose Us?</h3>
            </div>
            <div className={classes.Content}>
              <ul>
                <li>
                  Experience: We understand energy-market operations, <br />
                  grid constraints, and the practical demands of <br />
                  delivering power assets on site.
                </li>
                <li>
                  Quality and Reliability: We focus on dependable equipment,
                  <br />
                  disciplined deployment, and responsive service
                  <br />
                  for critical balancing and backup needs.
                </li>

                <li>
                  Digital Grid Systems: We build Industrial IoT telemetry,
                  <br />
                  VPP controls, and CPO platforms for OCPP EV chargers,
                  <br /> smart charging, load shifting, flexibility, and V2G.
                </li>
                <li>
                  Flexible Capacity: Load banks, batteries, and gensets
                  <br />
                  can support testing, reserve capacity, demand response,
                  <br />
                  and ancillary service opportunities.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
